import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpIcon from '@mui/icons-material/Help';
import Box from '@mui/material/Box';

import {BREAKPOINTS} from '../../../../const';
import useBreakpoint from '../../../../hooks/dom/useBreakpoint';
import useProfile from '../../../../hooks/providers/useProfile';
import Button from '../../../form/buttons/Button/Button';

const HeaderOnboardingButtonWithProgressPercentage = () => {
  const {onboardingData, getTotalNumberOfOnboardingSteps, getNumberOfCompletedOnboardingSteps, isOnboardingPopperOpen, setIsOnboardingPopperOpen, setOnboardingPopperAnchorEl} = useProfile();
  const breakpoint = useBreakpoint();
  const isExtraSmallScreen = breakpoint === BREAKPOINTS.xs;

  if (isExtraSmallScreen || onboardingData.length === 0) return null;

  const isSmallScreen = breakpoint === BREAKPOINTS.sm;

  const handleClick = e => {
    setIsOnboardingPopperOpen(true);
    setOnboardingPopperAnchorEl(e.currentTarget);
  };

  const totalNumberOfOnboardingSteps = getTotalNumberOfOnboardingSteps();
  const numberOfOnboardingStepsCompleted = getNumberOfCompletedOnboardingSteps();
  const onboardingProgressPercentage = Math.round((numberOfOnboardingStepsCompleted / totalNumberOfOnboardingSteps) * 100);

  const percentageText = `(${onboardingProgressPercentage}%)`;
  const buttonSize = isSmallScreen ? 'small' : 'medium';
  const fontSize = isSmallScreen ? 10 : 12;
  const iconFontSize = isSmallScreen ? 16 : 18;

  return (
    <Box display="flex" flex={1} justifyContent="flex-end">
      <Button size={buttonSize} onClick={handleClick} variant="contained" color="white" sx={{mr: isSmallScreen ? 1 : 2, fontSize, lineHeight: 1}}>
        <HelpIcon sx={{fontSize: iconFontSize}} />
        <Box ml={1}>Premiers pas</Box>
        <Box mr={isSmallScreen ? 1 : 1.5} ml={isSmallScreen ? 0.5 : 1}>
          {percentageText}
        </Box>
        {isOnboardingPopperOpen ? <ExpandMoreIcon sx={{fontSize: iconFontSize}} /> : <ExpandLessIcon sx={{fontSize: iconFontSize}} />}
      </Button>
    </Box>
  );
};

HeaderOnboardingButtonWithProgressPercentage.propTypes = {};

export default HeaderOnboardingButtonWithProgressPercentage;
